import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * Reports whether the current viewport is phone-sized (<768px).
 * SSR-safe: defaults to `false` until the first browser tick.
 */
export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT): boolean {
  const getMatches = React.useCallback(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
  }, [breakpoint]);

  const [isMobile, setIsMobile] = React.useState<boolean>(getMatches);

  React.useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isMobile;
}
